export const CrumbTitle = (path: string) => {
  switch (path) {
    case "candidates":
      return "Candidate Management";
    case "candidategroups":
      return "Group Management";
    case "leadcapture":
      return "Lead Capture";
    default:
      return path;
  }
};
